module.exports = __webpack_public_path__ + "static/media/RB_MonoGrey_RGB.10145924.svg";